import React from 'react'
import styled, { css } from 'styled-components'
import theme from '../../utils/theme'
import NextImage from 'components/elements/NextImage'

const CardContainer = styled.div<{ isReversed?: boolean; stopRotation?: boolean }>`
    display: flex;
    width: 100%;
    flex-direction: ${({ isReversed }) => (isReversed ? 'row-reverse' : 'row')};
    overflow: hidden;
    border-radius: ${theme.borderRadius.rounded};
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.06);
    transform: ${({ isReversed, stopRotation }) =>
        stopRotation ? css`rotate(0deg)` : isReversed ? css`rotate(1.4deg)` : css`rotate(-1.4deg)`};

    @media (max-width: 1050px) {
        flex-direction: column-reverse;
    }
`

const ContentSection = styled.div<{ textSectionColor?: string }>`
    background: ${({ textSectionColor }) =>
        textSectionColor ? textSectionColor : 'linear-gradient(240.86deg, #f9f9f9 0%, #f0eaf5 100%)'};

    padding: 32px;
    flex: 1;
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.borderRadius.rounded};
    border: 2px solid ${theme.colors.backgroundTransparent};
    z-index: 1;
    h3 {
        display: flex;
        align-items: center;
        gap: 10px;
    }
`

const AssetSection = styled.div<{ isReversed?: boolean; gradient?: string }>`
    flex: 1;
    background: ${({ gradient }) => (gradient ? gradient : 'linear-gradient(240.86deg, #512a99 0%, #004677 100%)')};
    border-radius: ${theme.borderRadius.rounded};
    border: 1px solid ${theme.colors.backgroundTransparent};
    padding: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 280px;
    img {
        object-fit: contain;
        max-width: 350px;
        max-height: 250px;
        @media (max-width: 750px) {
            max-width: 250px;
            max-height: 250px;
        }
        @media (max-width: 450px) {
            max-width: 100%;
            max-height: 150px;
        }
    }
`

interface Props {
    title?: string | JSX.Element
    description?: string
    buttonText?: string
    onButtonClick?: () => void
    assetContent?: StaticImageData | React.ReactNode
    isReversed?: boolean
    gradient?: string
    customContent?: React.ReactNode
    stopRotation?: boolean
    textSectionColor?: string
}

export const SideBySideInfoCard = ({
    title,
    description,
    buttonText,
    onButtonClick,
    assetContent,
    gradient,
    isReversed = false,
    customContent,
    stopRotation = false,
    textSectionColor,
}: Props) => {
    return (
        <CardContainer isReversed={isReversed} stopRotation={stopRotation}>
            <ContentSection textSectionColor={textSectionColor}>{customContent}</ContentSection>

            <AssetSection isReversed={isReversed} gradient={gradient}>
                {assetContent ? (
                    typeof assetContent === 'object' && assetContent !== null && 'height' in assetContent ? (
                        <NextImage
                            src={assetContent}
                            width={assetContent.width}
                            height={assetContent.height}
                            alt={typeof title === 'string' ? title : description ?? ''}
                            quality={100}
                        />
                    ) : (
                        assetContent
                    )
                ) : null}
            </AssetSection>
        </CardContainer>
    )
}

export default SideBySideInfoCard
